if (!customElements.get('ly-header-menu-desktop-item-lv1')) {
    customElements.define('ly-header-menu-desktop-item-lv1', class extends HTMLElement {

        connectedCallback() {
            const script = this.querySelector('script[type="application/json"][data-children]')
            if (script) {
                this.childrenData = readJsonFromScript(script)
            }

            this.addEventListener('mouseenter', this.handleLv1Enter)
            this.addEventListener('mouseleave', this.handleLv1Leave)
        }

        disconnectedCallback() {
            this.removeEventListener('mouseenter', this.handleLv1Enter)
            this.removeEventListener('mouseleave', this.handleLv1Leave)

            this.removeEvents()
        }

        handleLv1Enter = () => {
            this.onBeforeOpen()
            requestAnimationFrame(() => {
                this.classList.add('is-hovering')
            })
        }

        handleLv1Leave = () => {
            this.classList.remove('is-hovering')
        }

        onBeforeOpen = () => {
            if (this._childrenInited) return

            try {
                this._childrenInited = true
                this.initChildren()
            } catch (error) {
                this._childrenInited = false
            }
        }

        initChildren = () => {
            if (!this.childrenData || !this.childrenData.length) return

            // 外层容器
            const wrapper = document.createElement('div')
            wrapper.className = 'ly-header-menu-desktop-item-wrapper lv_1'

            const inner = document.createElement('div')
            inner.className = 'ly-header-menu-desktop-item-inner-wrapper lv_1'

            wrapper.appendChild(inner)

            // 判断是否有 lv3
            const hasLv3 = this.childrenData.some(item => item.children?.length)

            if (hasLv3) {
                wrapper.classList.add('featured')
                inner.appendChild(this.renderFeatured())
            } else {
                wrapper.classList.add('normal')
                inner.appendChild(this.renderNormal())
            }

            this.appendChild(wrapper)
        }

        renderFeatured = () => {
            const content = document.createElement('div')
            content.className = 'ly-header-menu-desktop-item-content-wrapper lv_1 featured'

            // lv2 左侧
            const lv2Wrapper = document.createElement('div')
            lv2Wrapper.className = 'ly-header-menu-desktop-item-featured-wrapper lv_2'

            // lv3 右侧
            const lv3Wrapper = document.createElement('div')
            lv3Wrapper.className = 'ly-header-menu-desktop-item-featured-wrapper lv_3'

            // 渲染 lv2 + lv3
            this.childrenData.forEach((lv2, index) => {
                const handle = lv2.handle

                // --- lv2 ---
                const lv2ItemLink = document.createElement('a')
                lv2ItemLink.className = `ly-header-menu-desktop-item-link-featured lv_2 ${index === 0 ? 'is-focus' : ''}`
                lv2ItemLink.dataset.handle = handle
                lv2ItemLink.href = lv2.link || '#'
                lv2ItemLink.textContent = lv2.title

                lv2Wrapper.appendChild(lv2ItemLink)

                // --- lv3 ---
                if (lv2.children?.length) {
                    const lv3Wrap = document.createElement('ly-header-menu-desktop-item-wrapper-lv3')
                    lv3Wrap.className = `ly-header-menu-desktop-item-wrapper lv_3 ${index === 0 ? 'is-focus' : ''}`
                    lv3Wrap.dataset.handle = handle

                    const lv3InnerWrap = document.createElement('div')
                    lv3InnerWrap.className = 'ly-header-menu-desktop-item-inner-wrapper lv_3'

                    const scroller = document.createElement('div')
                    scroller.className = 'ly-header-menu-desktop-item-inner-wrapper-scroller lv_3 ly-hide-scrollbar'
                    scroller.setAttribute('data-scroller', '')

                    lv2.children.forEach(lv3 => {
                        const item = document.createElement('div')
                        item.className = 'ly-header-menu-desktop-item-featured lv_3'

                        let coverHtml = ''
                        if (lv3.image) {
                            coverHtml = `
                            <div class="ly-header-menu-desktop-item-link-cover lv3">
                                <img
                                src="${lv3.image}&width=230" 
                                srcset="${lv3.image}&width=230 1x, ${lv3.image}&width=460 2x" 
                                width="230" 
                                height="230" 
                                loading="lazy">
                            </div>
                            `
                        }

                        item.innerHTML = `
                            <div class="ly-header-menu-desktop-item-inner-featured lv_3">
                                <a class="ly-header-menu-desktop-item-link-featured lv_3" href="${lv3.link || '#'}">
                                    ${coverHtml}
                                    <div class="ly-header-menu-desktop-item-link-title lv3">
                                        ${lv3.title}
                                    </div>
                                </a>
                            </div>
                        `

                        scroller.appendChild(item)
                    })

                    lv3InnerWrap.appendChild(scroller)
                    lv3Wrap.appendChild(lv3InnerWrap)

                    // 按钮（>3 才有）
                    if (lv2.children.length > 3) {
                        const btnWrap = document.createElement('div')
                        btnWrap.className = 'ly-header-menu-desktop-item-buttons lv_3'

                        btnWrap.innerHTML = `
                        <div class="ly-ctrl-buttons type-2">
                            <button class="ctrl-btn prev" data-carousel-button name="prev">
                                <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M316.28 514.711L699.53 131.46c17.574-17.573 17.574-46.066 0-63.64-17.573-17.573-46.066-17.573-63.64 0L189 514.712l446.891 446.892c17.574 17.573 46.067 17.573 63.64 0 17.574-17.574 17.574-46.066 0-63.64L316.28 514.711z" />
                                </svg>
                            </button>
                            <button class="ctrl-btn next" data-carousel-button name="next">
                                <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M766.504 515.072L383.252 131.82c-17.574-17.574-17.574-46.066 0-63.64 17.573-17.573 46.066-17.573 63.64 0l446.891 446.892-446.892 446.891c-17.573 17.574-46.066 17.574-63.64 0-17.573-17.573-17.573-46.066 0-63.64l383.253-383.251z" />
                                </svg>
                            </button>
                        </div>
                        `

                        lv3Wrap.appendChild(btnWrap)
                    }

                    lv3Wrapper.appendChild(lv3Wrap)
                }
            })

            content.appendChild(lv2Wrapper)
            content.appendChild(lv3Wrapper)

            queueMicrotask(() => this.addEvents())

            return content
        }

        renderNormal = () => {
            const content = document.createElement('div')
            content.className = 'ly-header-menu-desktop-item-content-wrapper lv_1 normal'

            const inner = document.createElement('div')
            inner.className = 'ly-header-menu-desktop-item-content-inner-wrapper lv_1 normal'

            this.childrenData.forEach(lv2 => {
                const link = document.createElement('a')
                link.className = 'ly-header-menu-desktop-item-link-normal lv_2'
                link.href = lv2.link || '#'
                link.textContent = lv2.title

                inner.appendChild(link)
            })

            content.appendChild(inner)
            return content
        }

        addEvents = () => {
            this.itemsLv2 = [...this.querySelectorAll('.ly-header-menu-desktop-item-link-featured.lv_2.lv_2[data-handle]')]
            this.itemsLv3 = [...this.querySelectorAll('.ly-header-menu-desktop-item-wrapper.lv_3[data-handle]')]

            this.removeHandlers = []

            this.itemsLv2.forEach((el, index) => {
                const handler = () => this.handleLv2Enter(el, index)
                el.addEventListener('mouseenter', handler)
                this.removeHandlers.push(() => el.removeEventListener('mouseenter', handler))
            })
        }

        handleLv2Enter = (hovering, index) => {
            const _handler = el => el.classList.toggle('is-focus', el.dataset.handle === hovering.dataset.handle)

            this.itemsLv2.forEach(_handler)

            const target = this.itemsLv3[index]

            if (target && target.dataset.handle === hovering.dataset.handle) {
                this.itemsLv3.forEach(_handler)
            }
        }

        removeEvents = () => {
            this.removeHandlers?.forEach(handler => handler())
        }
    })
}

if (!customElements.get('ly-header-menu-desktop-item-wrapper-lv3')) {
    customElements.define('ly-header-menu-desktop-item-wrapper-lv3', class extends HTMLElement {
        connectedCallback() {
            this.scroller = this.querySelector('[data-scroller]')
            this.buttons = [...this.querySelectorAll('[data-carousel-button]')]

            if (this.buttons.length <= 0) return

            this.buttons[0].disabled = true

            this.buttons.forEach(btn => {
                btn.addEventListener('click', this.handleClick)
            })

            this.scroller.addEventListener('scroll', this.handleScroll)
        }

        disconnectedCallback() {
            this.buttons.forEach(btn => {
                btn.removeEventListener('click', this.handleClick)
            })
            this.scroller.removeEventListener('scroll', this.handleScroll)
        }

        handleClick = evt => {
            if (evt.currentTarget.name === 'next') {
                this.scroller.scrollBy({
                    left: this.scroller.clientWidth,
                    behavior: 'smooth'
                })
            } else {
                this.scroller.scrollBy({
                    left: -this.scroller.clientWidth,
                    behavior: 'smooth'
                })
            }
        }

        #ticking = false
        handleScroll = () => {
            if (this.#ticking) return
            this.#ticking = true
            requestAnimationFrame(() => {
                const { scrollLeft, clientWidth, scrollWidth } = this.scroller
                this.buttons[0].disabled = scrollLeft <= 0
                this.buttons[1].disabled = scrollLeft + clientWidth >= scrollWidth - 1
                this.#ticking = false
            })
        }
    })
}